import { render, staticRenderFns } from "./CardRedirectPage.vue?vue&type=template&id=4c364339"
import script from "./CardRedirectPage.vue?vue&type=script&lang=js"
export * from "./CardRedirectPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports